<template>
  <div class="test-heading" v-loading="loading">
    <div class="case-creation__card">
      <div class="text-information-card">
        <div class="case-creation__heading border-bottom-none">
          <div class="title-with-icon">
            <span class="icon">
              <img
                src="@/assets/images/icons/icon-test-info.svg"
                alt="icon"
                class="img-fluid"
              />
            </span>
            <h3 class="title">Test Information</h3>
          </div>
        </div>
      </div>
    </div>
  </div>

  <section
    class="selected-tests-information"
    v-if="
      (panelsTestsData.selectedCategories &&
        panelsTestsData.selectedCategories.length > 0) ||
      (panelsTestsData.selectedGroup &&
        panelsTestsData.selectedGroup.length > 0)
    "
  >
    <el-checkbox-group
      v-model="panelsTestsData.selectedTestIds"
      class="case-vue-tabs"
    >
      <el-tabs>
        <el-tab-pane
          v-for="(test, index) of getSelectedCaseTypes()"
          :key="index"
        >
          <template #label>
            {{ index + 1 }}. {{ caseTypeMap[test.case_type_code] }}
          </template>
          <div v-if="test.case_type_code == 'TOXICOLOGY'">
            <ToxicologyTestsPreview
              :panelTestsData="panelsTestsData"
              :test="test"
              :allSelectedTests="allTests"
            >
            </ToxicologyTestsPreview>
          </div>
          <div v-else-if="test.case_type_code == 'WOUND'">
            <WoundPanelSelectedTests
              :panelTestsData="panelsTestsData"
              :test="test"
              :allSelectedTests="allTests"
            >
            </WoundPanelSelectedTests>
          </div>
          <div v-else-if="test.case_type_code == 'UTI'">
            <UTIPanelSelectedTests
              :panelTestsData="panelsTestsData"
              :test="test"
              :allSelectedTests="allTests"
            >
            </UTIPanelSelectedTests>
          </div>
          <div v-else-if="test.case_type_code == 'URINE_CULTURE'">
            <UrineCulturePanelSelectedTests
              :panelTestsData="panelsTestsData"
              :test="test"
              :allSelectedTests="allTests"
            >
            </UrineCulturePanelSelectedTests>
          </div>
          <div v-else-if="test.case_type_code == 'ENT'">
            <EntPanelSelectedTests
              :panelTestsData="panelsTestsData"
              :test="test"
              :allSelectedTests="allTests"
            >
            </EntPanelSelectedTests>
          </div>
          <div v-else-if="test.case_type_code == 'NAIL'">
            <NailPanelSelectedTests
              :panelTestsData="panelsTestsData"
              :test="test"
              :allSelectedTests="allTests"
            >
            </NailPanelSelectedTests>
          </div>
          <div v-else-if="test.case_type_code == 'GASTRO'">
            <GastroPanelSelectedTests
              :panelTestsData="panelsTestsData"
              :test="test"
              :allSelectedTests="allTests"
            >
            </GastroPanelSelectedTests>
          </div>
          <div v-else-if="test.case_type_code == 'CLINICAL_CHEMISTRY'">
            <BloodPanelSelectedTests
              :panelTestsData="panelsTestsData"
              :test="test"
              :allSelectedTests="allTests"
            >
            </BloodPanelSelectedTests>
          </div>
          <div v-else-if="test.case_type_code == 'STI'">
            <GTIWomensHealthTests
              :panelTestsData="panelsTestsData"
              :newCase="checkCaseValidation"
              :test="test"
              :allSelectedTests="allTests"
            ></GTIWomensHealthTests>
          </div>
          <div v-else-if="test.case_type_code == 'URINALYSIS'">
            <UrinalysisTestsPreview
              :panelTestsData="panelsTestsData"
              :newCase="checkCaseValidation"
              :test="test"
              :allSelectedTests="allTests"
            ></UrinalysisTestsPreview>
          </div>
          <div v-else-if="test.case_type_code == 'RESPIRATORY_PATHOGEN_PANEL'">
            <RespiratoryTestsPreview
              :panelTestsData="panelsTestsData"
              :newCase="checkCaseValidation"
              :test="test"
              :allSelectedTests="allTests"
            ></RespiratoryTestsPreview>
          </div>
          <div v-else-if="test.case_type_code == 'WOMENS_HEALTH'">
            <WomensHealthSelectedTests
              :panelTestsData="panelsTestsData"
              :test="test"
              :allSelectedTests="allTests"
            >
            </WomensHealthSelectedTests>
          </div>
          <div v-else>
            <DefaultPanelSelectedTests
              :panelTestsData="panelsTestsData"
              :testType="test"
              :allSelectedTests="allTests"
              :caseType="test.case_type_code"
            ></DefaultPanelSelectedTests>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-checkbox-group>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { defineAsyncComponent } from "vue";
import caseConstants from "@/config/constants/caseConstants";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
const WoundPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/WoundPanelSelectedTests"
  )
);
const UTIPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/UTIPanelSelectedTests"
  )
);
const UrineCulturePanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/UrineCulturePanelSelectedTests"
  )
);
const EntPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/EntPanelSelectedTests"
  )
);
const BloodPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/BloodPanelSelectedTests"
  )
);
const NailPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/NailPanelSelectedTests"
  )
);
const GastroPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/GastroPanelSelectedTests"
  )
);
const ToxicologyTestsPreview = defineAsyncComponent(() =>
  import("@/components/panels/testsPreview/ToxicologyTestsPreview")
);
const DefaultPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/DefaultPanelSelectedTests"
  )
);
const GTIWomensHealthTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/GTIWomensHealthTests"
  )
);
const UrinalysisTestsPreview = defineAsyncComponent(() =>
  import("@/components/panels/testsPreview/UrinalysisTestsPreview")
);
const RespiratoryTestsPreview = defineAsyncComponent(() =>
  import("@/components/panels/testsPreview/RespiratoryTestsPreview")
);
const WomensHealthSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/WomensHealthSelectedTests"
  )
);
export default {
  components: {
    WoundPanelSelectedTests,
    UTIPanelSelectedTests,
    UrineCulturePanelSelectedTests,
    EntPanelSelectedTests,
    ToxicologyTestsPreview,
    BloodPanelSelectedTests,
    DefaultPanelSelectedTests,
    NailPanelSelectedTests,
    GastroPanelSelectedTests,
    GTIWomensHealthTests,
    UrinalysisTestsPreview,
    RespiratoryTestsPreview,
    WomensHealthSelectedTests,
  },
  mixins: [UserPermissionsHelper],
  data() {
    return {
      loading: false,
      selectedTestIds: [],
      allTests: [],
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      caseId: "",
      UTIPanels: [],
      selectedCoriellPanels: [],
      selectedTab: null,
      panelsTestsData: {
        selectedTestIds: [],
        selectedCoriellPanels: [],
        selectedCategories: [],
        selectedGroup: [],
      },
    };
  },
  async mounted() {
    await this.checkCaseInformation();
  },
  computed: {
    ...mapGetters("pendingCases", [
      "getsinglePatientDetails",
      "getSinglePatientTestsInfo",
    ]),
    getTestsInformationObject() {
      const obj = {};
      if (this.allTests) {
        this.allTests.forEach((el) => {
          obj[el._id] = el;
        });
      }
      return obj;
    },
    selectedTestsDetails() {
      const data = [];
      if (this.panelsTestsData.selectedTestIds) {
        this.panelsTestsData.selectedTestIds.forEach((el) => {
          if (el && this.getTestsInformationObject[el]) {
            data.push(this.getTestsInformationObject[el]);
          }
        });
      }

      return data;
    },
  },
  methods: {
    async checkCaseInformation() {
      this.loading = true;
      this.caseId = this.$route.params.case_id;
      if (this.caseId) {
        await this.$store.dispatch("pendingCases/fetchSingleCaseInformation", {
          case_id: this.caseId,
        });
        if (!this.getCaseInformation) {
          this.disablePatientInformation = true;
        }

        await this.$store.dispatch("labTests/fetchLabGroupWiseTests", {
          get_all: true,
          lab_id: this.getUserPrimaryLabId,
          case_type_code: this.getsinglePatientDetails.case_types,
        });
        await this.$store.dispatch("labTests/fetchLabPanelsWiseTests", {
          get_all: true,
          lab_id: this.getUserPrimaryLabId,
          case_type_code: this.getsinglePatientDetails.case_types,
        });

        await this.$store.dispatch(
          "pendingCases/fetchSinglePatientTestsInfo",
          this.caseId
        );
        if (this.getSinglePatientTestsInfo) {
          this.panelsTestsData.selectedTestIds =
            this.getSinglePatientTestsInfo.map((el) => el._id);

          let casePanelsTestsInfo = this.getSinglePatientTestsInfo.filter(
            (test) => !test.group_id
          );
          let caseGroupsTestsInfo = this.getSinglePatientTestsInfo.filter(
            (test) => test.group_id
          );

          const transformedPanels = Object.values(
            casePanelsTestsInfo.reduce((acc, test) => {
              const key = `${test.panel_id}|${test.case_type_code}`;
              if (!acc[key]) {
                acc[key] = {
                  panel_id: test.panel_id,
                  case_type_code: test.case_type_code,
                  all_tests: true,
                  test_ids: [],
                };
              }
              acc[key].test_ids.push(test._id);
              return acc;
            }, {})
          );
          this.panelsTestsData.selectedCategories = transformedPanels;

          const uniqueGroups = Object.values(
            caseGroupsTestsInfo.reduce((acc, test) => {
              if (!acc[test.group_id]) {
                acc[test.group_id] = {
                  group_id: test.group_id,
                  group_code: test.group_code,
                  group_title: test.group_title,
                  case_type_code: test.case_type_code,
                };
              }
              return acc;
            }, {})
          );

          this.panelsTestsData.selectedGroup = uniqueGroups.map((e) => {
            e._id = e.group_id;
            e.panel_ids = Array.from(
              new Set(
                this.getSinglePatientTestsInfo
                  .filter((test) => test.group_id == e.group_id)
                  .map((test) => test.panel_id)
              )
            );
            e.case_type_code = e.case_type_code;
            return e;
          });
        }

        this.allTests = this.getSingleCaseTestsInfo;

        this.loading = false;
      }
    },

    getSelectedCaseTypes() {
      if (
        this.getsinglePatientDetails &&
        this.getsinglePatientDetails.case_types &&
        this.getsinglePatientDetails.case_types.length
      ) {
        let data = [
          ...this.panelsTestsData.selectedCategories,
          ...this.panelsTestsData.selectedGroup,
        ];
        const uniqueData = this.getSelectedCaseTypesGlobal(data);
        return uniqueData;
      } else {
        this.allTests = [];
        this.panelsTestsData.selectedTestIds = [];
        this.panelsTestsData.selectedCategories = [];
        this.panelsTestsData.selectedGroup = [];
      }
      return [];
    },
    goToEditForm() {
      this.$router.push({
        name: "PendingCasesEdit",
        params: { case_id: this.caseId },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    // selecting tests based on UTI coriell panels
  },
};
</script>

<style lang="scss">
.test-heading {
  .case-creation__card {
    .text-information-card {
      display: flex;
      justify-content: space-between;
    }

    .test-information-header {
      display: flex;
      align-content: center;

      p {
        font-size: 13px;
        font-weight: 500;
        margin: 0 5px;
        color: #f24a55;
        margin-top: 1px;
      }

      .el-button {
        border: 0;
        padding: 0 4px 0 12px;
        min-height: 30px;

        &:hover {
          background-color: #fff;
        }

        &:active {
          background-color: #fff;
        }

        &:focus {
          background-color: #fff;
        }

        .edit-icon {
          display: flex;
          align-items: center;

          img {
            width: 15px;
            height: 15px;
          }

          p {
            color: #828282;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss"></style>
